var Lightbox = require('@blizzard/gs2-styleguide/gs2/components/lightbox/lightbox');
var $lightboxes = Array.from(
    (window).document.querySelectorAll('.web-event-template .lightbox'));
// add logic for lightboxes if there are lightboxes on the page
if ($lightboxes.length) {
    var lightbox = new Lightbox.default();
    lightbox.initialize();
}